import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren} from "@angular/core";
import {AbstractControl, FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {StockItemService} from "../../services/stock-item-service/stock-item.service";
import {StockItemFormComponent} from "../stock-item-form/stock-item-form.component";
import {NewStockViewComponent} from "../../stock/new-stock-view/new-stock-view.component";
import {Stock} from "../../../shared/view-model/stock";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import * as _ from "lodash";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {ErrorHandlerService} from "../../../core/visbos-core/error-handling/error-handler.service";
import {ManufacturerService} from "../../../crm/services/manufacturer.service";

@Component({
  selector: 'vb-add-stock-item',
  templateUrl: './add-stock-item.component.html',
  styleUrls: ['./add-stock-item.component.css']
})
export class AddStockItemComponent implements OnInit, AfterViewChecked {

  form: FormGroup;

  storedControls: string[] = [];
  JSON;
  console;

  item;

  @ViewChildren(AbstractVisbosControl)
  childForms: QueryList<AbstractVisbosControl<any, any>>;

  constructor(private fb: FormBuilder, private cd: ChangeDetectorRef,
              private siService: StockItemService,
              private sessionActions: SessionActions,
              private err: ErrorHandlerService,
              private manuService: ManufacturerService) {
    this.JSON = JSON;
    this.console = console;
  }

  ngOnInit() {
    this.initForm();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  private initForm() {
    this.form = this.fb.group({
      stock_item: StockItemFormComponent.initControl(this.fb),
      stocks: this.fb.array([])
    });
  }

  deleteStock(index: number) {
    let ctrl = <FormArray>this.form.get('stocks');
    ctrl.removeAt(index);
  }

  addStock(values?: Stock) {
    let ctrl = NewStockViewComponent.initControl(this.fb);
    (<FormArray>this.form.get('stocks')).push(ctrl);
  }

  save(formData) {
    let stockInput = this.completeFormData(formData);

    this.siService.createStockItem(stockInput.stock_item, stockInput.stocks).subscribe((result: any) => {
        this.reset();
        this.sessionActions.pushMessage('Artikel erfolgreich angelegt', MessageType.SUCCESS);
      },
      error => {
        this.err.handleUserError(error, "Fehler beim Anlegen des Artikels!");
      });

  }

  reset(fullReset: boolean = false) {

    if (fullReset) {
      this.storedControls = [];
    }

    let values: any[] = [];

    // Store values of marked controls

    for (let key of this.storedControls) {
      let ctrl: AbstractControl = this.form.get(key);
      if (ctrl) {
        values.push(ctrl.value);
      } else {
        let i = this.storedControls.indexOf(key);
        this.storedControls[i] = null; // Set to null, so array is not modified during iteration
      }
    }
    this.storedControls = this.storedControls.filter(n => n); // Filter out null values
    this.cd.detectChanges();

    // Reset values to default
    this.childForms.forEach(child => child.reset(fullReset));
    this.cd.detectChanges();

    // Restore values
    for (let index in this.storedControls) {
      let ctrl = this.form.get(this.storedControls[index]);
      if (ctrl) {
        ctrl.setValue(values[index]);
        ctrl.markAsTouched();
      }
    }

  }

  reloadData() {

  }

  completeFormData(item) {
    let data = Object.assign({}, item);

    if (_.has(data, 'stock_item.medicine')) {
      _.set(data, 'stock_item.medicine.administration_unit_id', _.get(item, 'stock_item.administration_unit_id'));
      _.set(data, 'stock_item.medicine.substances.0.administration_unit_id', _.get(item, 'stock_item.administration_unit_id'));
      _.set(data, 'stock_item.medicine.stock_item_id', _.get(item, 'stock_item.cuid'));
    }

    if (_.has(data, 'stock_item.products')) {
      data.stock_item.products.forEach(p => p.stock_item_id = _.get(item, 'stock_item.cuid'));
    }

    if (_.has(data, 'stocks')) {
      data.stocks.forEach(stock => stock.stock_item_id = _.get(item, 'stock_item.cuid'));
    }

    return data;
  }


}




// WEBPACK FOOTER //
// ./src/app/store-management/stock-item/add-stock-item/add-stock-item.component.ts